var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "23px",
    viewBox: "0 0 15 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "back") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0.58     0     0     0     0               0     0.74     0     0     0               0     0     0.22     0     0               0     0     0     1     0 "
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kurzanfrage-Copy-2",
    transform: "translate(-154.000000, -1959.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "btn",
    transform: "translate(132.000000, 1942.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/angebot",
    transform: "translate(18.000000, 17.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.500000, 11.500000) rotate(-270.000000) translate(-11.500000, -11.500000) "
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.06155104,22.8911573 C6.43825104,22.8911573 5.83929271,22.651574 5.36012604,22.196749 C4.42613438,21.2627573 4.42613438,19.728801 5.36012604,18.7949052 L12.6197406,11.5110927 L5.36012604,4.22823854 C4.42613438,3.29424688 4.42613438,1.76029063 5.36012604,0.826394792 C6.29411771,-0.107596875 7.82807396,-0.107596875 8.76196979,0.826394792 L17.7463448,9.81076979 C18.2011698,10.2655948 18.4407531,10.8645531 18.4407531,11.5121948 C18.4407531,12.1588781 18.1768281,12.7578365 17.7463448,13.2136198 L8.76196979,22.1970365 C8.28280313,22.6518615 7.6604375,22.8914448 7.06147917,22.8914448 L7.06155104,22.8911573 Z",
    id: "arrow_1920906",
    fill: "#FFFFFF",
    transform: "translate(11.550193, 11.508673) rotate(-270.000000) translate(-11.550193, -11.508673) "
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.615109a69cbf86953ae989ea5674a714.svg";
export { ForwardRef as ReactComponent };